import React from 'react';
import { realWeddings } from '../../data/realWeddings';
export function RealWeddings() {
  return <section className="mx-auto mt-14 max-w-5xl px-6" aria-labelledby="real-weddings-heading" data-id="element-41" data-mp="1cce0goc74j0">
      <p className="text-center font-sans text-[9px] font-medium uppercase tracking-[0.35em] text-ink/60" data-id="element-42" data-mp="63ayztk9sqsl">
        Real weddings
      </p>
      <h2 id="real-weddings-heading" className="mx-auto mt-3 max-w-xl text-center font-heading text-2xl font-light uppercase leading-snug tracking-[0.06em] text-logo md:text-3xl" data-id="element-43" data-mp="b2e4tg82r11m">
        Three days, one property, everyone you love under the same trees
      </h2>
      <ul className="mt-10 grid grid-cols-1 gap-8 md:grid-cols-3" data-id="element-44" data-mp="3jhxte1xsvvac">
        {realWeddings.map(wedding => <li key={wedding.couple} className="flex flex-col" data-id="element-45" data-mp="3ojeqrnh2szm6">
            <img src={wedding.image} alt={`${wedding.couple} on their wedding day at Twenty Mile House`} className="aspect-square w-full object-cover" loading="lazy" data-id="element-46" data-mp="ytb3vseru3vg" />
            <p className="mt-3 font-display text-base italic text-ink/70" data-id="element-47" data-mp="nukuft018v97">{wedding.tag}</p>
            <h3 className="mt-1 font-condensed text-2xl font-medium uppercase tracking-[0.14em] text-logo" data-id="element-48" data-mp="iwj911f4wjuk">
              {wedding.couple}
            </h3>
            <p className="mt-1.5 font-body text-sm leading-relaxed text-ink/75" data-id="element-49" data-mp="9vlcf470zem0">
              {wedding.description}
            </p>
          </li>)}
      </ul>
    </section>;
}